// Mock data storage for booking functionality
let bookings = [];

export const handleBooking = (formData) => {
  // Simulate saving booking
  const booking = {
    id: Date.now(),
    ...formData,
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  
  bookings.push(booking);
  
  console.log('New booking received:', booking);
  console.log('All bookings:', bookings);
  
  return {
    success: true,
    booking: booking,
    message: 'Booking successfully created'
  };
};

export const getBookings = () => {
  return bookings;
};

export const clearBookings = () => {
  bookings = [];
  return { success: true, message: 'All bookings cleared' };
};
